export const uidToUrl = (uid) => {
  if(uid)
    return uid.split('_').join('/')
  return null
}

/*
 * Sorts services to predefined order
 */
export const sortedServices = services => {

  const sortedServices = []


  const developService = services.find(service => service.uid === 'develop')
  if (developService) {
    sortedServices.push(developService)
  }

  const dynamicService = services.find(service => service.uid === 'dynamics_365')
  if (dynamicService) {
    sortedServices.push(dynamicService)
  }

  const devopsService = services.find(service => service.uid === 'devops')
  if (devopsService) {
    sortedServices.push(devopsService)
  }

  const datascienceService = services.find(service => service.uid === 'datascience')
  if (datascienceService) {
    sortedServices.push(datascienceService)
  }



  return sortedServices
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js